'use client';

import { createContext, useContext } from 'react';
export const IsWebViewContext = createContext<boolean>(false);
export const useIsWebView = () => {
  return useContext(IsWebViewContext);
};
interface IsWebviewProviderProps {
  children: React.ReactNode;
  isWebView: boolean;
}
export const IsWebviewProvider = ({
  children,
  isWebView
}: IsWebviewProviderProps) => {
  return <IsWebViewContext.Provider value={isWebView} data-sentry-element="IsWebViewContext.Provider" data-sentry-component="IsWebviewProvider" data-sentry-source-file="IsWebviewProvider.tsx">{children}</IsWebViewContext.Provider>;
};